import React from 'react';

export default function SectionHeader({ eyebrow, title, subtitle, center = false }) {
  return (
    <div className={`mb-12 ${center ? 'text-center flex flex-col items-center' : ''}`}>
      {eyebrow && <span className="eyebrow mb-3">{eyebrow}</span>}
      <h2 className="font-display text-4xl md:text-5xl font-bold text-[#2b1d0e] leading-tight">{title}</h2>
      <div className={`h-divider my-4 ${center ? '' : ''}`} />
      {subtitle && <p className="text-[#5c4020] text-base md:text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
  );
}
